import React from "react";
import CurrencyFormat from "react-currency-format";
import { Radio } from "@rmwc/radio";
import EditPriceItem from "../../EditPriceItem/EditPriceItem";
import { getRoofPitchLabel } from "../../../utils/Functions";

const RoofPitchSetting = (props) => {
	const { params, const_var, changeBuildingRoof } = props;

	return (
		<div className="form-group">
			<div className="control-label-bar justify-content-start">
				<label className="control-label">Roof Pitch</label>
			</div>

			{Object.entries(const_var.BuildingRoofPitch).map(([key, value]) => {
				let roofStyleExist = "";

				const label = getRoofPitchLabel(const_var.BuildingRoofPitchObj, key);

				if (const_var.BuildingRoofPitchObj != undefined && const_var.BuildingRoofPitchObj[key] != undefined && const_var.BuildingRoofPitchObj[key].roof_ids != undefined) {
					roofStyleExist = const_var.BuildingRoofPitchObj[key].roof_ids.includes(params.p_r_s) || const_var.BuildingRoofPitchObj[key].roof_ids.includes("0");
				}

				if (!roofStyleExist && roofStyleExist == "") {
					return null;
				}

				const showBarnRoof =
					params.m_s_n == 3 &&
					const_var.defaultBuildingArr[const_var.BuldingIDforReset] &&
					const_var.defaultBuildingArr[const_var.BuldingIDforReset]?.image_name.split(".").includes("Straight_Roof_Barns") &&
					((const_var.editAPIDataByResponse != undefined && (const_var.editAPIDataByResponse.data?.main_created_at == undefined || const_var.editAPIDataByResponse.data?.main_created_at >= "2024-07-01")) ||
						const_var.crmSetting.is_Edit == false);

				return (
					<div className="radio-group with-wrap" key={key}>
						<Radio
							label={showBarnRoof && const_var.checkRoofDefault == value ? key : label}
							value={params.b_r_p}
							checked={params.b_r_p == value}
							name={params.b_r_p + " Roof Pitch"}
							onClick={() =>
								changeBuildingRoof({
									event: value,
									value: "center"
								})
							}
						/>

						{showBarnRoof && const_var.checkRoofDefault == value ? <span className="additional-info ml-1">Standard</span> : null}

						{params.b_r_p == value ? (
							<>
								{const_var.post_data.building != undefined && const_var.loginSession == true ? (
									<div className="price-box">
										<EditPriceItem jsonObj={const_var.post_data.building?.roof_pitch_price ?? 0} jsonObjKey="roof_pitch_price" />
									</div>
								) : (
									<div className="price-box-type-2">
										{const_var.hide_price_calculation != 1 &&
											const_var.loginSession == false &&
											const_var.post_data.building &&
											const_var.post_data.building.roof_pitch_price !== undefined &&
											const_var.post_data.building.roof_pitch_price !== 0 && (
												<CurrencyFormat value={const_var.post_data.building.roof_pitch_price} displayType="text" thousandSeparator={true} prefix="$" />
											)}
									</div>
								)}
							</>
						) : null}
					</div>
				);
			})}
		</div>
	);
};

export default RoofPitchSetting;
